<!-- NgBootstrap Modal Template -->
<ng-template #userPermissionsModal let-modal>
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
            User Permissions
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                <rect y="0.696289" width="24" height="24" rx="12" fill="white" />
                <path d="M6.99988 7.69653L12.0514 12.748L17.1029 7.69653" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.99995 18.3679L12.0505 13.3164L17.1021 18.3679" stroke="currentColor" stroke-width="1.6"
                    stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>
    </div>

    <!-- Modal Body -->
    <div class="modal-body p-0" style="max-height: 60vh; overflow-y: auto;">
        <!-- Loader -->
        <div class="loaderwrapper" *ngIf="loader">
            <span class="loader"></span>
        </div>
        <div class="px-4 py-3 bg-light border-bottom">
            <div class="row g-3">
                <div class="col-md-3">
                    <div class="d-flex gap-3">
                        <label class="text-muted small mb-1">Role Name</label>
                        <div class="fw-semibold">{{ selectedRole?.name || 'N/A' }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="d-flex gap-3">
                        <label class="text-muted small mb-1">User Type</label>
                        <div class="fw-semibold">{{ selectedRole?.user_type_name || 'N/A' }}</div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="d-flex gap-3">
                        <label class="text-muted small mb-1">Description</label>
                        <div class="fw-semibold text-break">{{ selectedRole?.description || 'N/A' }}</div>
                    </div>
                </div>
                <!-- <div class="col-md-3">
                    <label class="text-muted small mb-1">User Type</label>
                    <div class="fw-semibold">{{ selectedRole?.user_type_name || 'N/A' }}</div>
                </div> -->
                <!-- <div class="col-md-3">
                    <label class="text-muted small mb-1">Status</label>
                    <div>
                        <span class="badge badge-custom" [ngClass]="selectedRole?.status ? 'badge-success' : 'badge-danger'">
                            {{ selectedRole?.status ? 'Active' : 'Inactive' }}
                        </span>
                    </div>
                </div> -->
                <!-- <div class="col-md-3">
                    <label class="text-muted small mb-1">Assigned Users</label>
                    <div class="fw-semibold">
                        <i class="bi bi-people me-1"></i>{{ selectedRole?.users_count || 0 }}
                    </div>
                </div> -->
            </div>
            <!-- <div class="row mt-2" *ngIf="selectedRole?.description">
                <div class="col-12">
                    <label class="text-muted small mb-1">Description</label>
                    <div class="text-break">{{ selectedRole.description }}</div>
                </div>
            </div> -->
        </div>

        <!-- Permissions Table -->
        <div class="table-responsive table-container" *ngIf="!loader">
            <table class="table table-border table-hover mb-0">
                <!-- table-light -->
                <thead class="sticky-top">
                    <tr>
                        <th style="min-width: 250px;">Screen Permission</th>
                        <th class="text-center" style="width: 100px;">Select All</th>
                        <th class="text-center" style="width: 80px;">Read</th>
                        <th class="text-center" style="width: 80px;">Create</th>
                        <th class="text-center" style="width: 80px;">Edit</th>
                        <th class="text-center" style="width: 80px;">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let group of groupedScreenPermissions; trackBy: trackByModuleId">
                        <!-- Module Header Row -->
                        <!-- <tr class="table-active">
                            <td colspan="6" class="fw-bold" style="background-color: #f5f8fa; padding: 12px 16px;">
                                <i class="bi bi-folder2-open me-2"></i>{{ group.moduleName }}
                            </td>
                        </tr> -->
                        <tr class="table-active">
                            <td class="fw-bold" style="background-color: #f5f8fa; padding: 12px 16px;">
                                {{ group.moduleName }}
                            </td>
                            <td class="text-center" style="background-color: #f5f8fa;">
                                <input class="form-check-input" type="checkbox"
                                    [checked]="isAllModulePermissionsSelected(group)"
                                    (change)="toggleAllModulePermissions(group)" />
                            </td>
                            <td colspan="4" style="background-color: #f5f8fa;"></td>
                        </tr>
                        <!-- Screen Rows -->
                        <tr *ngFor="let permission of group.screens; trackBy: trackByMenuId">
                            <td style="padding-left: 40px;">
                                <!-- <i class="bi bi-arrow-return-right me-2 text-muted"></i> -->
                                {{ permission.displayName }}
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox"
                                    [checked]="isAllPermissionsSelected(permission)"
                                    (change)="toggleAllPermissions(permission)" />
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" [ngModel]="permission.canView"
                                    (ngModelChange)="onViewPermissionChange(permission, $event)" />
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" [ngModel]="permission.canAdd"
                                    (ngModelChange)="permission.canAdd = $event" [disabled]="!permission.canView" />
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" [ngModel]="permission.canEdit"
                                    (ngModelChange)="permission.canEdit = $event" [disabled]="!permission.canView" />
                            </td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" [ngModel]="permission.canDelete"
                                    (ngModelChange)="permission.canDelete = $event" [disabled]="!permission.canView" />
                            </td>
                        </tr>
                    </ng-container>
                    <tr *ngIf="groupedScreenPermissions.length === 0 && !loader">
                        <td class="text-center text-muted p-4" colspan="6">
                            <i class="bi bi-inbox me-2"></i>
                            <span>No menu for permissions</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-orange" (click)="updateRolePermissions()" [disabled]="loader">Save</button>
        <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.dismiss()">Close</button>
        <button type="button" class="btn btn-orange" (click)="updateRolePermissions()" [disabled]="loader">Save
            Changes</button> -->
    </div>
</ng-template>